import Typography from '@mui/material/Typography';
import React, { FC } from 'react';
import { getKmuVariante, KMU_VARIANTE } from './utils';

const UploadKmuHinweise: FC<{ antragsFormular: string }> = ({ antragsFormular }) => {
	const kmuVariante = getKmuVariante(antragsFormular);
	switch (kmuVariante) {
		case KMU_VARIANTE.erste:
			return (
				<Typography>
					<strong>Wichtig:</strong> Die unterzeichnete KMU-Selbsterklärung ist Bestandteil des Förderantrags. Der Upload der Erklärung an dieser
					Stelle ist daher wichtig für die Einreichung Ihres vollständigen Antrags auf Förderung.
				</Typography>
			);

		case KMU_VARIANTE.zweite:
			return (
				<Typography>
					<strong>Wichtig:</strong> Die unterzeichnete KMU-Selbsterklärung und die KMU-Selbsterklärung-Berechnung sind Bestandteil des
					Förderantrags. Der Upload der Dokumente erleichtert die zeitnahe Sichtung und Prüfung Ihres Antrags.
				</Typography>
			);
		default:
			return <></>;
	}
};
export default UploadKmuHinweise;
